import { Injectable, signal } from '@angular/core';
import type { BuiltForm } from '../models/built-form';

export interface FormPreviewHandoff {
  slug: string;
  form: BuiltForm;
  previewMode: 'desktop' | 'mobile';
}

@Injectable({ providedIn: 'root' })
export class FormPreviewHandoffService {
  readonly snapshot = signal<FormPreviewHandoff | null>(null);

  set(snapshot: FormPreviewHandoff): void {
    this.snapshot.set({
      slug: snapshot.slug.trim(),
      form: {
        ...snapshot.form,
        pages: snapshot.form.pages.map((page) => ({
          ...page,
          cta: { ...page.cta },
          fields: page.fields.map((field) => ({ ...field })),
        })),
      },
      previewMode: snapshot.previewMode,
    });
  }

  /** Read the draft without clearing it, so the builder can restore it on return. */
  peekForSlug(slug: string): FormPreviewHandoff | null {
    const current = this.snapshot();
    if (!current || current.slug !== slug.trim()) {
      return null;
    }
    return current;
  }

  takeForSlug(slug: string): FormPreviewHandoff | null {
    const current = this.peekForSlug(slug);
    if (!current) {
      return null;
    }
    this.snapshot.set(null);
    return current;
  }

  clear(): void {
    this.snapshot.set(null);
  }
}
